import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import ReactSpinner from 'react16-spinjs';
import { changeAdminSettings } from '../../utils/adminUtils';
import './SettingsModal.scss';

const messages = defineMessages({
  accountName: {
    id: 'accountName',
    defaultMessage: 'Account Name'
  },
  cname: {
    id: 'cname',
    defaultMessage: 'CNAME (optional)'
  },
  settingsError: {
    id: 'settingsError',
    defaultMessage: 'This name cannot be used. Please choose another name.'
  },
  nameInUseError: {
    id: 'nameInUseError',
    defaultMessage: 'This name is in use. Please choose another name.'
  }
});

const spinnerConfig = {
  lines: 13,
  length: 37,
  width: 19,
  radius: 47,
  color: '#413675',
  speed: 0.7
};

let isMounted;

class SettingsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: {
        hostname: props.hostname || '',
        cname: props.cname || ''
      },
      sendingCommand: false,
      error: props.error
    };
  }

  componentDidMount() {
    isMounted = true;
  }

  componentWillUnmount() {
    isMounted = false;
  }

  validateForm = () => (
    (this.state.config.hostname && this.state.config.hostname.length) &&
    ((this.state.config.hostname !== this.props.hostname) ||
    (this.state.config.cname !== this.props.cname)));

  render() {
    const { hostname, cname, intl, setModal, firstTime, domain } = this.props;

    if (this.state.sendingCommand) {
      return (
        <div className="settingsModal">
          <ReactSpinner config={spinnerConfig} />
        </div>
      );
    }

    return (
      <div className="settingsModal">
        <h2 className="settingsTitle">
          {firstTime ?
            <FormattedMessage
              id="settingsFirstTitle"
              defaultMessage="First, set up your Lifesize Share account"
            />
          :
            <FormattedMessage
              id="settingsTitle"
              defaultMessage="Lifesize Share account settings"
            />
          }
        </h2>
        <div className="settingsInputGroup">
          <div className="settingsLabel">
            <FormattedMessage
              {...messages.accountName}
            />
          </div>
          <div className="settingsSubGroup">
            <div className="settingsInputContainer">
              <input
                type="text"
                className="settingsInput"
                value={this.state.config.hostname}
                placeholder={intl.formatMessage(messages.accountName)}
                onChange={(evt) => {
                  const validatedString = evt.target.value.replace(/[^a-zA-Z0-9-_]/g, '');

                  this.setState({
                    config: Object.assign({},
                    this.state.config,
                    { hostname: validatedString })
                  });
                }}
              />
              <div className="domainBlock">
                .{domain}
              </div>
            </div>
            <div className="settingsSubLabel">
              <FormattedMessage
                id="namedAccountInstructions"
                defaultMessage="Enter a name for your account. This will allow you to manage all of your Lifesize Share from one place."
              />
            </div>
          </div>
        </div>
        <div className="settingsInputGroup">
          <div className="settingsLabel">
            <FormattedMessage
              {...messages.cname}
            />
          </div>
          <div className="settingsSubGroup">
            <input
              type="text"
              className="settingsInput"
              defaultValue={cname}
              placeholder={intl.formatMessage(messages.cname)}
              onChange={(evt) => {
                this.setState({
                  config: Object.assign({},
                  this.state.config,
                  { cname: evt.target.value })
                });
              }}
            />
            <div className="settingsSubLabel">
              <FormattedMessage
                id="cnameDescription"
                defaultMessage="Add a CNAME to your DNS to point directly to your list of Share devices (i.e. share.yourdomain.com)"
              />
            </div>
          </div>
        </div>
        <div className="buttonBar">
          {this.state.error && <div className="settingsError">{this.state.error}</div>}
          <button
            className={`mainButton ${this.validateForm() ? '' : 'disabled'}`}
            disabled={!this.validateForm()}
            onClick={() => {
              changeAdminSettings(this.state.config).then((res) => {
                if (isMounted) {
                  this.setState({ sendingCommand: false });
                }
                window.location = res.redirect;
              })
              .catch((res) => {
                if (isMounted) {
                  const error = res.error && res.error[0] === 'ERROR_HOSTNAME_IN_USE' ?
                    intl.formatMessage(messages.nameInUseError) :
                    intl.formatMessage(messages.settingsError);

                  this.setState({
                    sendingCommand: false,
                    error
                  });
                }
              });
            }}
          >
            <FormattedMessage
              id="saveSettingsButton"
              defaultMessage="Save"
            />
          </button>
          {setModal && <button
            className="mainButton secondaryButton"
            onClick={() => {
              setModal(null);
            }}
          >
            <FormattedMessage
              id="cancelButton"
              defaultMessage="Cancel"
            />
          </button>}
        </div>
      </div>
    );
  }
}

SettingsModal.propTypes = {
  intl: PT.object,
  setModal: PT.func,
  hostname: PT.string,
  cname: PT.string,
  error: PT.string,
  firstTime: PT.bool,
  domain: PT.string
};

export default injectIntl(SettingsModal);



// WEBPACK FOOTER //
// ./src/components/SettingsModal/SettingsModal.js